/* tslint:disable */
/* eslint-disable */
/**
 * users
 * users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RecordMentionUsageRequest
 */
export interface RecordMentionUsageRequest {
    /**
     * 
     */
    type: RecordMentionUsageRequestTypeEnum;
    /**
     * 
     */
    id: string;
}


/**
 * @export
 */
export const RecordMentionUsageRequestTypeEnum = {
    User: 'user',
    Group: 'group',
} as const;
export type RecordMentionUsageRequestTypeEnum = typeof RecordMentionUsageRequestTypeEnum[keyof typeof RecordMentionUsageRequestTypeEnum];


/**
 * Check if a given object implements the RecordMentionUsageRequest interface.
 */
export function instanceOfRecordMentionUsageRequest(value: object): value is RecordMentionUsageRequest {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function RecordMentionUsageRequestFromJSON(json: any): RecordMentionUsageRequest {
    return RecordMentionUsageRequestFromJSONTyped(json, false);
}

export function RecordMentionUsageRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RecordMentionUsageRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'id': json['id'],
    };
}

export function RecordMentionUsageRequestToJSON(json: any): RecordMentionUsageRequest {
    return RecordMentionUsageRequestToJSONTyped(json, false);
}

export function RecordMentionUsageRequestToJSONTyped(value?: RecordMentionUsageRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'id': value['id'],
    };
}

